package com.essntl.features.organization.ui.organizationdetails

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.features.address.ui.AddressEvent
import com.essntl.features.address.ui.AddressState
import com.essntl.features.address.ui.AddressValidation
import com.essntl.features.organization.domain.model.OrganizationModel
import com.essntl.features.organization.ui.organizationdetails.components.ContactListColumn
import com.essntl.features.organization.ui.organizationdetails.components.DetailsScreen
import com.essntl.features.organization.ui.organizationdetails.components.OrganizationDetailsHeader
import com.essntl.features.service.ui.allservice.AllServiceEvent
import com.essntl.features.service.ui.allservice.AllServiceState
import com.essntl.features.service.ui.allservice.components.ServicesGrid
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.toggle.TabState
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun OrganizationDetailsScreen(
    state: OrganizationDetailsState,
    onEvent: (OrganizationDetailsEvent) -> Unit,
    onNavigation: (OrganizationDetailsNavigation) -> Unit,
    addressState: AddressState,
    onAddressEvent: (AddressEvent) -> Unit,
    addressValidation: AddressValidation,
    allServiceState: AllServiceState,
    onEventAllService: (AllServiceEvent) -> Unit,
) {
    val tabItems = remember(state.organization.value.type) {
        if (state.organization.value.type ==
            OrganizationModel.Type.Supplier
        )
            listOf(
                TabState(index = 0, text = "Contacts"),
                TabState(index = 1, text = "Details"),
                TabState(index = 2, text = "Services"),
            )
        else
            listOf(
                TabState(index = 0, text = "Contacts"),
                TabState(index = 1, text = "Details"),
            )
    }

    val (selectedTabIndex, setSelectedTabIndex) = remember {
        mutableStateOf(tabItems.first().index)
    }

    Column(
        modifier = Modifier.fillMaxSize(),
    ) {
        OrganizationDetailsHeader(
            state = state,
            onEvent = onEvent,
            onNavigation = onNavigation,
            tabItems = tabItems,
            selectedTabIndex = selectedTabIndex,
            setSelectedTabIndex = setSelectedTabIndex,
        )

        Spacer(modifier = Modifier.height(1.spacing))

        if (selectedTabIndex == 0)
            ContactListColumn(
                state = state,
                onNavigation = onNavigation,
                modifier = Modifier
                    .fillMaxWidth()
                    .weight(1f),
            )
        else if (selectedTabIndex == 1)
            DetailsScreen(
                state = state,
                onEvent = onEvent,
                addressState = addressState,
                onAddressEvent = onAddressEvent,
                addressValidation = addressValidation,
            )
        else if (selectedTabIndex == 2) {
            if (allServiceState.getAllServiceOrganization.data.orEmpty().isEmpty())
                Box(
                    contentAlignment = Alignment.Center,
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(top = 1.spacing)
                        .height(200.dp)
                        .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
                        .background(MaterialTheme.esColorScheme.bgSecondary),
                ) {
                    if (allServiceState.getAllServiceOrganization.isLoading)
                        EsSpinner()
                    else if (allServiceState.getAllServiceOrganization.isFailure)
                        Text(
                            text = "Something goes wrong!",
                            color = MaterialTheme.esColorScheme.textSecondary,
                            style = MaterialTheme.esTypography.p1Medium16,
                        )
                    else if (allServiceState.getAllServiceOrganization.data.orEmpty().isEmpty())
                        Text(
                            text = "No services found!",
                            color = MaterialTheme.esColorScheme.textSecondary,
                            style = MaterialTheme.esTypography.p1Medium16,
                        )
                }
            else
                ServicesGrid(
                    state = allServiceState,
                    onEvent = onEventAllService,
                    organisationServices = true,
                    onNavigation = {},
                )
        }
    }
}